import styled from '@emotion/styled';
import { AutoComplete } from 'src/components-dummy';

export const AutoCompleteStyled = styled(AutoComplete)`
  max-width: 100%;
  width: 100% !important;
`;
